<template>
  <div>
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med info fra innflyttingsprotokoll
    </v-alert>
    <v-flex xs12>
      <h2 class="text-center mb-3">Gassmåler</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <div v-if="stepValues.bool.isWaterMeter.value">
      <v-flex xs12 class="mb-3"  v-for="(meter, index) in stepValues.meters" :key="index">
        <TextInput v-model="meter.numbers" @update-fields="updateFields" ></TextInput>
        <div class="text-right" v-if="stepValues.meters.length > 1">
          <v-btn color="red" class="mb-4 mt-2" @click="removeMeter(index)">Fjern denne måleren</v-btn>
        </div>
      </v-flex>
      <v-btn color="success" class="mb-4 mt-2" @click="addMeter()">Legg til måler</v-btn>
    </div>
    <ImageUploadBox v-if="stepValues.bool.isWaterMeter.value" :images="stepValues.images" :relatedImages="stepValues.relatedImages"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  beforeMount: function() {
    if(this.protocol.related_protocol && this.stepValues) {
      if(this.protocol.related_protocol.steps.water.saved_values) {
        if(!this.stepValues.loadedFromRelated) {
          this.stepValues.loadedFromRelated = true
          let values = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.water.saved_values))
          this.stepValues.bool = values.bool
          this.stepValues.relatedImages = values.images
          this.stepValues.numbers.waterMeterNumber = values.numbers.waterMeterNumber
          if(values.meters != null && values.meters != undefined) {
            this.stepValues.meters = values.meters
          }
        }
      }
    }
    if(this.stepValues.meters == null || this.stepValues.meters == undefined) {
      this.stepValues.meters = []
    }
    if(this.stepValues.meters.length == 0) {
      this.stepValues.meters.push({numbers: JSON.parse(JSON.stringify(this.stepValues.numbers))})
    }
  },
  methods: {
    addMeter: function() {
      this.stepValues.meters.push({numbers: JSON.parse(JSON.stringify(this.stepValues.numbers))})
    },
    removeMeter: function(i) {
      this.stepValues.meters.splice(i, 1);
    }
  }
}
</script>
